import {
    GET_FAULTS,
    GET_FAULTS_FAIL,
    GET_FAULTS_SUCCESS,
    SELECT_FAULT,
    SELECT_FAULT_BY_ID,
    START_DRAWING_FAULT,
    FINISH_DRAWING_FAULT,
    CANCEL_DRAWING_FAULT,
    START_DRAWING_FAULT_PHOTO,
    FINISH_DRAWING_FAULT_PHOTO,
    CANCEL_DRAWING_FAULT_PHOTO,
    GET_FAULT_PHOTOS_AND_VIDEOS_SUCCESS,
    GET_FAULT_PHOTOS_AND_VIDEOS,
    GET_FAULT_PHOTOS_AND_VIDEOS_FAIL,
    EDIT_FAULT,
    EDIT_FAULT_SUCCESS,
    EDIT_FAULT_FAIL,
    ADD_FAULT,
    ADD_FAULT_SUCCESS,
    ADD_FAULT_FAIL,
    GET_FAULT_TAGS_DICTIONARY,
    GET_FAULT_TAGS_DICTIONARY_SUCCESS,
    GET_FAULT_TAGS_DICTIONARY_FAIL,
    DELETE_FAULT,
    DELETE_FAULT_SUCCESS,
    DELETE_FAULT_FAIL,
    CLEAR_MESSAGE,
} from './../types/faults';

export const getFaults = (axiosInstance) => ({
    type: GET_FAULTS,
    axiosInstance: axiosInstance,
});

export const getFaultsSuccess = (faults) => ({
    type: GET_FAULTS_SUCCESS,
    faults,
});

export const getFaultsFail = () => ({
    type: GET_FAULTS_FAIL,
});

export const getFaultPhotosAndVideos = (axiosInstance, faultId) => ({
    type: GET_FAULT_PHOTOS_AND_VIDEOS,
    axiosInstance: axiosInstance,
    faultId: faultId,
});

export const getFaultPhotosAndVideosSuccess = (faultPhotos, faultVideos) => ({
    type: GET_FAULT_PHOTOS_AND_VIDEOS_SUCCESS,
    faultPhotos,
    faultVideos,
});

export const getFaultPhotosAndVideosFail = () => ({
    type: GET_FAULT_PHOTOS_AND_VIDEOS_FAIL,
});

export const getFaultTagsDictionary = (axiosInstance) => ({
    type: GET_FAULT_TAGS_DICTIONARY,
    axiosInstance: axiosInstance,
});

export const getFaultTagsDictionarySuccess = (faultTagsDictionary) => ({
    type: GET_FAULT_TAGS_DICTIONARY_SUCCESS,
    faultTagsDictionary,
});

export const getFaultTagsDictionaryFail = () => ({
    type: GET_FAULT_TAGS_DICTIONARY_FAIL,
});

export const editFault = (axiosInstance, faultFeature) => ({
    type: EDIT_FAULT,
    axiosInstance,
    faultFeature,
});

export const editFaultSuccess = (faultFeature) => ({
    type: EDIT_FAULT_SUCCESS,
    faultFeature,
});

export const editFaultFail = (error) => ({
    type: EDIT_FAULT_FAIL,
    error,
});

export const addFault = (axiosInstance, faultFeature) => ({
    type: ADD_FAULT,
    axiosInstance,
    faultFeature,
});

export const addFaultSuccess = (faultFeature) => ({
    type: ADD_FAULT_SUCCESS,
    faultFeature,
});

export const addFaultFail = (error) => ({
    type: ADD_FAULT_FAIL,
    error,
});

export const deleteFault = (axiosInstance, faultId) => ({
    type: DELETE_FAULT,
    axiosInstance,
    faultId,
});

export const deleteFaultSuccess = (faultId) => ({
    type: DELETE_FAULT_SUCCESS,
    faultId,
});

export const deleteFaultFail = (error) => ({
    type: DELETE_FAULT_FAIL,
    error,
});

export const selectFault = (fault) => ({
    type: SELECT_FAULT,
    fault,
});

export const selectFaultById = (faultId) => ({
    type: SELECT_FAULT_BY_ID,
    faultId,
});

export const startDrawingFault = (fault) => ({
    type: START_DRAWING_FAULT,
    fault,
});

export const finishDrawingFault = () => ({
    type: FINISH_DRAWING_FAULT,
});

export const cancelDrawingFault = () => ({
    type: CANCEL_DRAWING_FAULT,
});

export const startDrawingFaultPhoto = () => ({
    type: START_DRAWING_FAULT_PHOTO,
});

export const finishDrawingFaultPhoto = () => ({
    type: FINISH_DRAWING_FAULT_PHOTO,
});

export const cancelDrawingFaultPhoto = () => ({
    type: CANCEL_DRAWING_FAULT_PHOTO,
});

export const clearMessage = () => ({
    type: CLEAR_MESSAGE,
});


// WEBPACK FOOTER //
// ./src/actions/faults.jsx